// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-reviews_wrapper__ty4uY","container":"footer-reviews_container__zA_4X"};